<template>
    <GridCategorias />
 </template>

<script>
// import Sistemas from './components/Sistemas.vue';
// import SistemasPorCategoria from './components/SistemasPorCategoria.vue';
import GridCategorias from './components/GridCategorias.vue';

export default {
    name: 'App',

    components: {
        // SistemasPorCategoria,
        GridCategorias,
    },
}
</script>
 <style>
 </style>